import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import { Link } from "@material-ui/core";
import OverflowTooltip from "../../../components/OverflowTooltip/OverflowTooltip";
import { urlNormalizer } from "../../../helpers";
import { EducationType } from "../../school/constants/types";

const useStyles = makeStyles(() => ({
  root: {
    padding: 4,
    height: 64,
    border: "1px solid #C5C5C5",
    borderRadius: 15,
    "&+&": {
      marginTop: 24,
    },
  },
  avatarLabelTextContainer: {
    width: "calc(100% - 52px)",
    display: "flex",
    columnGap: 12,
  },
  avatar: {
    width: 40,
    height: 40,
  },
  labelTextContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    color: " #231F20",
  },
  text: {
    fontSize: 12,
    color: " #858997",
  },
  link: {
    fontSize: 12,
    fontWeight: 500,
    color: "#2f80ed",
    "&:hover": {
      color: "#1368d8",
      cursor: "pointer",
    },
  },
  n_a: {
    fontSize: 12,
    color: "#858997",
  },
  receiptContainer: {
    "&.MuiGrid-item": {
      paddingLeft: 0,
    },
  },
}));

const BillingCard = ({
  avatar,
  studentName,
  degree,
  level,
  schoolName,
  major,
  grade,
  amount,
  receiptImage,
  language,
  category,
  schoolType,
}) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} alignItems={"center"} className={classes.root}>
      <Grid item xs={12} md={studentName && schoolName ? 3 : 4}>
        <div className={classes.avatarLabelTextContainer}>
          <Avatar src={avatar} className={classes.avatar} />
          <div className={classes.labelTextContainer}>
            <div className={classes.label}>
              <OverflowTooltip text={studentName || schoolName} />
            </div>
            <div className={classes.text}>
              <OverflowTooltip text={degree || level || category} />
            </div>
          </div>
        </div>
      </Grid>
      {studentName && schoolName && (
        <Grid item xs={12} md={3}>
          <div className={classes.labelTextContainer}>
            <div className={classes.label}>School</div>
            <div className={classes.text}>
              <OverflowTooltip text={schoolName} />
            </div>
          </div>
        </Grid>
      )}
      <Grid item xs={12} md={studentName && schoolName ? 3 : 4}>
        {schoolType === EducationType.Language && (
          <div className={classes.labelTextContainer}>
            <div className={classes.label}>Language</div>
            <div className={classes.text}>
              <OverflowTooltip text={language} />
            </div>
          </div>
        )}
        {schoolType === EducationType.Secondary && (
          <div className={classes.labelTextContainer}>
            <div className={classes.label}>Grade</div>
            <div className={classes.text}>
              <OverflowTooltip text={grade} />
            </div>
          </div>
        )}
        {schoolType === EducationType.Higher && (
          <div className={classes.labelTextContainer}>
            <div className={classes.label}>Major</div>
            <div className={classes.text}>
              <OverflowTooltip text={major} />
            </div>
          </div>
        )}
      </Grid>
      <Grid item xs={12} md={studentName && schoolName ? 2 : 3}>
        <div className={classes.labelTextContainer}>
          <div className={classes.label}>Amount</div>
          <div className={classes.text}>
            <OverflowTooltip text={amount} />
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={1} className={classes.receiptContainer}>
        <div className={classes.labelTextContainer}>
          <div className={classes.label}>Receipt</div>
          <div>
            {receiptImage ? (
              <Link
                className={classes.link}
                href={urlNormalizer(receiptImage)}
                target="_blank"
                underline="none"
              >
                View
              </Link>
            ) : (
              <span className={classes.n_a}>N/A</span>
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default React.memo(BillingCard);
